import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ILanguageModelStatsService = ( createDecorator('ILanguageModelStatsService'));
export { ILanguageModelStatsService };
